import { connect } from 'react-redux';

import { makeGetTaskSubtasksCount, makeGetTaskCompletedSubtasksCount } from '../selectors/tasks';

import ProgressCountComponent from 'components/ProgressCountComponent';

const SubtasksOverview = ({ completedSubtasksCount, subtasksCount }) => {
    return <ProgressCountComponent completedCount={completedSubtasksCount} totalCount={subtasksCount} />;
};

const makeMapStateToProps = () => {
    const getTaskSubtasksCount = makeGetTaskSubtasksCount();
    const getTaskCompletedSubtasksCount = makeGetTaskCompletedSubtasksCount();

    return ({ tasks }, ownProps) => ({
        subtasksCount: getTaskSubtasksCount(tasks.items, ownProps.taskId),
        completedSubtasksCount: getTaskCompletedSubtasksCount(tasks.items, ownProps.taskId)
    });
};

export default connect(makeMapStateToProps)(SubtasksOverview);
